import { Injectable } from "@angular/core";
import {
  QuestionnaireScore,
  MobilityQuestionnaire,
  QuestionnaireSubmissionInterface,
} from "src/app/core/models/mobility-questionnaire";
import { BackendService } from "src/app/core/services/backend-service";
import {
  UserQuestionnaireResultDto,
  QuestionnaireResponseMapper,
} from "./questionnaire-response-mapper";

@Injectable({
  providedIn: "root",
})
export class QuestionnaireService extends BackendService {
  async getQuestionnaire(): Promise<MobilityQuestionnaire | null> {
    const response = await this.get<UserQuestionnaireResultDto>(
      "api/mobility-questionnaire"
    );

    return response
      ? QuestionnaireResponseMapper.mapWrappedResponse(response)
      : null;
  }

  async saveSubmission(submission: QuestionnaireSubmissionInterface): Promise<{
    maturityLevel: "Low" | "Medium" | "High";
    score: QuestionnaireScore;
    success: boolean;
    completedAt: Date | null;
  }> {
    return await this.post<
      QuestionnaireSubmissionInterface,
      {
        maturityLevel: "Low" | "Medium" | "High";
        score: QuestionnaireScore;
        success: boolean;
        completedAt: Date | null;
      }
    >("api/mobility-questionnaire/save", submission);
  }

  async createQuestionnaire(): Promise<MobilityQuestionnaire> {
    const response = await this.post<{}, UserQuestionnaireResultDto>(
      "api/mobility-questionnaire/create",
      {}
    );
    return QuestionnaireResponseMapper.mapWrappedResponse(response);
  }

  async deleteQuestionnaire(): Promise<void> {
    return await this.delete<void>("api/mobility-questionnaire");
  }

  private _mapQuestionnaireResponse(
    response: UserQuestionnaireResultDto | null
  ): MobilityQuestionnaire | null {
    if (!response) {
      return null;
    }

    return QuestionnaireResponseMapper.mapWrappedResponse(response);
  }
}
